import { alpha } from "@mui/material";
import {
  blue,
  cyan,
  green,
  indigo,
  lime,
  orange,
  pink,
  purple,
  teal,
  yellow,
  grey,
} from "@mui/material/colors";
import { AccountColour } from "__generated__/graphql";

export const getAccountColour = (colour: AccountColour): string => {
  switch (colour) {
    case AccountColour.Col1:
      return alpha(green[300], 0.5);
    case AccountColour.Col2:
      return alpha(yellow[300], 0.5);
    case AccountColour.Col3:
      return alpha(blue[300], 0.5);
    case AccountColour.Col4:
      return alpha(pink[300], 0.5);
    case AccountColour.Col5:
      return alpha(purple[300], 0.5);
    case AccountColour.Col6:
      return alpha(indigo[300], 0.5);
    case AccountColour.Col7:
      return alpha(cyan[300], 0.5);
    case AccountColour.Col8:
      return alpha(teal[300], 0.5);
    case AccountColour.Col9:
      return alpha(lime[300], 0.5);
    case AccountColour.Col10:
      return alpha(orange[300], 0.5);
    case AccountColour.ColDefault:
      return grey[300];
  }
};
